import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarService {
    collapsed = false;

    toggle(): void {
        this.collapsed = !this.collapsed;
    }

    set(collapsed: boolean): void {
        this.collapsed = collapsed;
    }
}
